import { CommonModule } from '@angular/common';
import { Component, HostBinding, TemplateRef } from '@angular/core';
import { ToastService } from '@core/toast.service';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Toast, ToastPosition } from '@shared/interfaces/toasts.interface';

@Component({
  selector: 'app-toasts',
  templateUrl: './toasts-container.component.html',
  imports: [NgbToastModule, TranslateModule, CommonModule],
  host: {
    class: 'toast-container position-fixed',
  },
})
export class ToastsContainerComponent {
  @HostBinding('style.z-index') zIndex = '1200';
  @HostBinding('style.top') get top(): string | null {
    return this.currentPosition?.top ?? null;
  }
  @HostBinding('style.right') get right(): string | null {
    return this.currentPosition?.right ?? null;
  }
  @HostBinding('style.bottom') get bottom(): string | null {
    return this.currentPosition?.bottom ?? null;
  }
  @HostBinding('style.left') get left(): string | null {
    return this.currentPosition?.left ?? null;
  }
  @HostBinding('style.transform') get transform(): string | null {
    return this.currentPosition?.transform ?? null;
  }

  constructor(public toastService: ToastService) {}

  isTemplate(toast: Toast): boolean {
    return toast.textOrTpl instanceof TemplateRef;
  }

  private get currentPosition(): ToastPosition | undefined {
    return [...this.toastService.toasts].reverse().find(toast => toast.position)
      ?.position;
  }
}
